import { useEffect, useRef } from 'react';
import { useFormStore } from '../store/useFormStore';
import { formsApi } from '../services/api';

export function useAutoSave(delay = 30000) {
  const { caseId, formData, setSaveStatus } = useFormStore();
  const timerRef  = useRef(null);
  const lastRef   = useRef(null);

  useEffect(() => {
    if (!caseId) return;
    const snapshot = JSON.stringify(formData);
    if (snapshot === lastRef.current) return;

    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(async () => {
      try {
        setSaveStatus('saving');
        const latestFormData = useFormStore.getState().formData;
        await formsApi.save(caseId, latestFormData);
        lastRef.current = JSON.stringify(latestFormData);
        setSaveStatus('saved');
        setTimeout(() => setSaveStatus('idle'), 2500);
      } catch {
        setSaveStatus('error');
      }
    }, delay);

    return () => { if (timerRef.current) clearTimeout(timerRef.current); };
  }, [formData, caseId, delay, setSaveStatus]);
}
